import {
  AbilityBuilder,
  AbilityClass,
  ConditionsMatcher,
  mongoQueryMatcher,
  PureAbility,
} from '@casl/ability';
import { ModuleEnum } from 'abi-compliance-common-types';
import type { AuthSession } from '@ghq-abi/auth-client-lib/shared/types';

enum Action {
  List = 'list',
  Create = 'create',
  View = 'view',
  Update = 'update',
  Manage = 'manage',
  Vote = 'vote',
  Facilitate = 'facilitate',
  Proxy = 'proxy',
  Unlock = 'unlock',
  Skip = 'skip',
  Delete = 'delete',
}

export type Entities =
  | 'Home'
  | 'Ticket'
  | 'FeatureFlags'
  | 'MyLCM'
  | 'Cheershub'
  | 'Compensation'
  | 'HelperFooter'
  | 'User'
  | 'MyRequests'
  | 'ConflictOfInterest'
  | 'GiftsAndDonations'
  | `${ModuleEnum}`;

export type AbilityTuple = [`${Action}`, Entities | Record<string, unknown>];

export type AppAbility = PureAbility<AbilityTuple>;

/* const allowedZonesToApps = {
  cheershub: [
    "MAZ",
    "SAZ",
    "GHQ",
    "GLO",
    "NO-ZONE",
    "GLOBAL",
    "ZONE MIDDLE AMERICAS",
    "ZONE SOUTH AMERICA",
    "ZONE EUROPE",
    "ZONE AFRICA",
    "ZONE ASIA PACIFIC",
  ],
  rewards: [
    "EUR",
    "SAZ",
    "GHQ",
    "GLO",
    "NO-ZONE",
    "GLOBAL",
    "ZONE SOUTH AMERICA",
    "ZONE EUROPE",
  ],
  compensation: [
    "AFR",
    "MAZ",
    "NAZ",
    "EUR",
    "ZONE MIDDLE AMERICAS",
    "ZONE EUROPE",
    "APAC",
    "GHQ",
    "GLOBAL",
  ],
}; */

export function createUserAbility(
  user?: AuthSession['user'],
  rules?: AppAbility['_indexedRules']
) {
  const { can, build } = new AbilityBuilder(
    PureAbility as AbilityClass<AppAbility>
  );

  // const originalUserRoles =
  //   user?.rols ?? ({} as Exclude<Session['user']['rols'], null>);
  // const userRoles =
  //   user?.px?.rols ??
  //   user?.rols ??
  //   ({} as Exclude<Session['user']['rols'], null>);
  // const userManagedZones = user?.px?.zones ?? user?.zones ?? [];

  /* const isManager = user?.px?.rols.isManager ?? user?.rols?.isManager ?? false; */

  // Map user Abilities

  can(Action.View, 'Home');
  can(Action.View, 'ConflictOfInterest');
  can(Action.Skip, 'FeatureFlags');
  can(Action.View, 'HelperFooter');
  can(Action.View, 'Cheershub');
  can(Action.View, 'Compensation');
  can(Action.View, 'MyLCM');
  can(Action.View, 'Ticket');
  can(Action.Proxy, 'User');
  can(Action.View, 'MyRequests');

  const ability = build({
    conditionsMatcher: mongoQueryMatcher as ConditionsMatcher<unknown>,
  });

  if (rules) {
    ability.update(rules);
  }

  return ability;
}
